module.exports = __webpack_public_path__ + "static/media/taffiethule01.c592823e.jpg";